const state = {
  show: false,
  text: '',
  icon: '',
  block: false,
  spinner: false,
  requestError: ''
}

const defaults = {
  text: '',
  icon: '',
  block: false,
  spinner: false,
  requestError: false
}

const mutations = {
  SHOW_MODAL (state, {
    text = defaults.text,
    icon = defaults.icon,
    block = defaults.block,
    spinner = defaults.spinner,
    requestError = defaults.requestError
  } = defaults) {
    state.show = true
    state.text = text
    state.icon = icon
    state.block = block
    state.spinner = spinner
    state.requestError = requestError
  },
  HIDE_MODAL (state) {
    state.show = false
    state.text = ''
    state.block = false
    state.spinner = false
    state.requestError = ''
  }
}

export default {
  state,
  mutations
}



/** WEBPACK FOOTER **
 ** ./src/vuex/modules/modal.js
 **/